const API_KEY = "aa624f6ce07ed4c8ac10eedc9f98b9f6";
const requests = {
  fetchPopular: `/discover/movie?api_key=${API_KEY}&with_genres=38`,

  fetchNetflixOriginals: `/discover/all?api_key=${API_KEY}&with_networks=213`,
  fetchComedyMovies: `/discover/movie?api_key=${API_KEY}&with_genres=35`,
  fetchHorrorMovies: `/discover/movie?api_key=${API_KEY}&with_genres=27`,
  fetchDocumentaries: `/discover/movie?api_key=${API_KEY}&with_genres=99`,
};

export default requests;
